module.exports = __webpack_public_path__ + "static/media/matchpointlogo.34194a21.png";